import React from "react";
import SleepSummarySection from "./sleep-summary-section";

/**
 * Step 1: Sleep summary + technologist comment + assign to (editable).
 * Step 2: Same summary + technologist comment (read-only) + coach interpretation box.
 */
export default function SleepSummaryStep({
    step = 1,
    adminList,
    reportId,
    setReportGeneratedSuccessAlert,
    setSleepReportModalOpen,
    loadWaitingData,
    onSleepReportGenerated,
    onBack,
    ...props
}) {
    return (
        <SleepSummarySection
            {...props}
            stepMode={step}
            adminList={adminList}
            reportId={reportId}
            setReportGeneratedSuccessAlert={setReportGeneratedSuccessAlert}
            setSleepReportModalOpen={setSleepReportModalOpen}
            loadWaitingData={loadWaitingData}
            onSleepReportGenerated={onSleepReportGenerated}
            onBack={onBack}
        />
    );
}
